import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, MultiSelect, Panel } from '@ipc/ipc-components';

import { PanelContent } from '../../../styles';
import { ALA_LEVELS_OPTIONS_WITHOUT_ALL } from '../../../utils/constants';
import { FormLabel } from '../../../elements';

const AlaLevelsComponent = ({
  values, validations, selectChangeHandler, allAlaLevelsChecked, allAlaLevelsCheckboxHandler,
}) => (
  <Panel title="ALA Levels" expanded>
    <PanelContent>
      <div className="FormRow">
        <FormLabel title="Select ALA levels to be included in ALA agreement" required hasError={!validations.alaLevels}>
          <div className="FormRowInlineFlex">
            <MultiSelect
              value={values.alaLevels}
              options={ALA_LEVELS_OPTIONS_WITHOUT_ALL}
              className="Input MultiSelect"
              onChange={selectChangeHandler}
              name="alaLevels"
              isDisabled={allAlaLevelsChecked}
            />
            <Checkbox
              label="All ALA Levels"
              name="allAlaLevels"
              className="LeftTab"
              onChange={allAlaLevelsCheckboxHandler}
              checked={allAlaLevelsChecked}
            />
          </div>
        </FormLabel>
      </div>
    </PanelContent>
  </Panel>
);

AlaLevelsComponent.propTypes = {
  values: PropTypes.shape(),
  validations: PropTypes.shape(),
  selectChangeHandler: PropTypes.func,
  allAlaLevelsChecked: PropTypes.bool,
  allAlaLevelsCheckboxHandler: PropTypes.func,
};

export default AlaLevelsComponent;
